// Quiz upsell ATC Functionality
if (!customElements.get('quiz-upsell-items')) {
  class QuizUpsellItems extends HTMLElement {
    static observedAttributes = ["data-second-shade"];

    constructor() {
      super();

      this.upsellVersion = this.dataset.upsellVersion;
      this.upsell = this.dataset.upsell;
      this.upsellFreeAc = this.dataset.upsellFreeAc;
      this.brush = this.dataset.brush;
      this.zipCode = this.dataset.zipCode;
      this.selectedShade = this.dataset.selectedShade;
      this.secondShade = this.dataset.secondShade;

      this.atcButton = this.querySelector('[data-quiz-upsell-atc]');

      document.querySelectorAll('[data-quiz-upsell-atc]').forEach(button => {
        if (button !== this.atcButton) {
          button.innerHTML = this.atcButton.innerHTML;
        }
      });

      this.fetchConfig = fetchConfig('javascript');
      this.fetchConfig.headers['X-Requested-With'] = 'XMLHttpRequest';

      this.handleClickBind = this.handleClick.bind(this);
    }

    attributeChangedCallback(name, oldValue, newValue) {
      this.secondShade = newValue;
    }

    connectedCallback() {
      this.ShadeDropdown = this.querySelector('.shade-dropdown');
      window.addEventListener('click', this.handleClickBind);
    }

    addButtonAttributes() {
      document.querySelectorAll('[data-quiz-upsell-atc], [data-quiz-regular-atc]').forEach(button => {  
        button.setAttribute("disabled", "disabled");  
        button.classList.add('active');  
      });  
    }
    removeButtonAttributes() {
      document.querySelectorAll('[data-quiz-upsell-atc], [data-quiz-regular-atc]').forEach(button => {  
        button.removeAttribute("disabled");
        button.classList.remove('active');
      });  
    }

    handleClick(evt) {
      const upsellATCButton = evt.target.closest('[data-quiz-upsell-atc]');
      const regularATCButton = evt.target.closest('[data-quiz-regular-atc]');
      if (upsellATCButton) {
        this.upsellATC(true);
      } else if (regularATCButton) {
        this.upsellATC(false);
      }
    }

    // Method for Criteo tracking, which returns a Promise
    criteoTracking(itemArray, data) {
      return new Promise((resolve, reject) => {
        try {
          // Retrieve email from localStorage
          const quizUserEmail = localStorage.getItem("quizUserEmail") || "";
          //console.log('Item added to cart:', data); // Log the added item data

          window.criteo_q = window.criteo_q || [];
          const deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";

          // Prepare the items array for Criteo, mapping over itemArray to get variants
          const itemsToTrack = itemArray.map((item, index) => {
            return {
              id: item.id,  // Variant ID, not product ID
              price: Shopify.formatMoney(data.items[index].final_price),  // Access the final_price from data.items -  final price is caculated after all discounts
              quantity: item.quantity  // Quantity of the variant being added
            };
          });

          window.criteo_q.push(
            { event: "setAccount", account: 84368 },
            { event: "setEmail", email: quizUserEmail, hash_method: "sha256" },
            { event: "setEmail", email: quizUserEmail, hash_method: "md5" },
            { event: "setSiteType", type: deviceType },
            { event: "setZipcode", zipcode: this.zipCode },
            { event: "addToCart", item: itemsToTrack }
          );

          // Resolve promise after the tag is fired
          resolve("Criteo Tag Fired Successfully");
        } catch (error) {
          console.error("Error in Criteo Tag:", error);
          reject(error);  // Reject the promise in case of any error
        }
      });
    }


    upsellATC(upgradeOrder) {
      const itemArray = [];

      
      if (this.selectedShade && this.selectedShade !== '') {
        itemArray.push({
          quantity: 1,
          id: this.selectedShade
        });
      }

      if (this.brush && this.brush !== '') {
        itemArray.push({
          quantity: 1,
          id: this.brush
        });
      }

      if (upgradeOrder) {

        if (!this.secondShade || this.secondShade === '') {
          this.selectShadeError();
          return;
        }

        if (this.upsell && this.upsell !== '') {
          const upsellItem = {
            quantity: 1,
            id: this.upsell,
          };
  
          if (this.upsellVersion === 'ec-1') {
            upsellItem.properties = {
              _quiz_upsell_components_ec1: `${this.selectedShade},${this.secondShade}`
            }
          }
          
          itemArray.push(upsellItem);
        }

        if (this.upsellFreeAc && this.upsellFreeAc !== '') {
          const upsellItem = {
            quantity: 1,
            id: this.upsellFreeAc,
          };
  
          if (this.upsellVersion === 'ec-2') {
            upsellItem.properties = {
              _quiz_upsell_components_ec2: `${this.upsell},${this.selectedShade},${this.secondShade}`
            }
          }
  
          if (this.upsellVersion === 'mw') {
            upsellItem.properties = {
              _quiz_upsell_components_mw: `${this.upsell},${this.selectedShade},${this.secondShade}`
            }
          }
          
          itemArray.push(upsellItem);
        }

        if (this.secondShade && this.secondShade !== '') {
          const secondShadeItem = {
            quantity: 1,
            id: this.secondShade
          };

          if (this.upsellVersion === 'ac-1' || this.upsellVersion === 'ec-1' || this.upsellVersion === 'ec-2' || this.upsellVersion === 'mw') {
            secondShadeItem.properties = {
              _quiz_upsell_components_free_shade: `${this.selectedShade},${this.upsell}`
            }
          }

          itemArray.push(secondShadeItem);
        }
      }

      if (itemArray.length > 0) {
        this.atc(itemArray, upgradeOrder);
      }
    }

    atc(itemArray, upgradeOrder) {
      document.body.classList.add('hide-upcart');
      this.fetchConfig.body = JSON.stringify({ 'items': itemArray });

      this.addButtonAttributes();

      fetch(routes.cart_add_url, this.fetchConfig)
        .then((response) => {
          if (response.ok) {
            return response.json(); // Parse the response JSON
          } else {
            throw new Error('Failed to add item to cart');
          }
        })
        .then((data) => {
          // Call criteoTracking and wait for it to resolve before redirecting
          this.criteoTracking(itemArray, data)
            .then(() => {
              const addCartAttribute = this.addCartAttribute(upgradeOrder)
              console.log(addCartAttribute)
              addCartAttribute.then(() => {
                window.location.href = '/checkout';  // Redirect after Criteo tracking
              });
            })
            .catch((error) => {
              const addCartAttribute = this.addCartAttribute(upgradeOrder)
              console.log(addCartAttribute)
              addCartAttribute.then(() => {
                console.error("Criteo Tracking failed, proceeding to checkout:", error);
                window.location.href = '/checkout';  // Redirect even if Criteo tracking fails
              });
            });
        })
        .catch((error) => {
          console.error('Error:', error);
          document.body.classList.remove('hide-upcart');
          this.removeButtonAttributes();
        });
    }

    selectShadeError() {
      this.ShadeDropdown?.selectShadeError();
    }

    addCartAttribute(upgradeOrder) {
      const attributeFetch = fetch(routes.cart_update_url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          attributes: {
            '_cc_quiz_atc': upgradeOrder ? 'CCQUIZUPSELL' : 'CCQUIZNOUPSELL'
          }
        }),
      })
      .then(res => res.json())
      .catch(err => console.error(err));
      
      return attributeFetch;
    }
  }
  customElements.define('quiz-upsell-items', QuizUpsellItems);
}

// Quiz upsell shade selector dropdown
if (!customElements.get('shade-dropdown')) {
  class ShadeDropdown extends HTMLElement {
    constructor() {
      super();

      this.fetchConfig = fetchConfig('javascript');
      this.fetchConfig.headers['X-Requested-With'] = 'XMLHttpRequest';

      this.handleClickBind = this.handleClick.bind(this);
      this.handleChangeBind = this.handleChange.bind(this);
    }

    connectedCallback() {
      this.QuizUpsellItems = this.closest('.quiz-upsell-items');
      this.dropdownButton = this.querySelector('[data-open-shade-dropdown]');
      this.dropdownButtonText = this.dropdownButton?.querySelector('.shade-dropdown__button-text');
      this.dropdown = this.querySelector('.shade-dropdown__dropdown');

      this.addEventListener('click', this.handleClickBind);
      this.addEventListener('change', this.handleChangeBind);
    }
    
    disconnectedCallback() {
      this.removeEventListener('click', this.handleClickBind);
      this.removeEventListener('change', this.handleChangeBind);
    }

    handleClick(evt) {
      const dropDownButton = evt.target.closest('[data-open-shade-dropdown]');
      if (dropDownButton) {
        this.toggle();
      }
    }

    handleChange(evt) {
      const shadeOption = evt.target.closest('[name="shade-option"]');
      if (shadeOption) {
        this.close();
        this.updateSelectedShade(shadeOption);
      }
    }

    updateSelectedShade(shadeOption) {
      if (shadeOption && this.dropdownButton) {
        this.classList.remove('shade-dropdown--error');
        this.dropdownButton.classList.remove('shade-dropdown__button--perfect-match');
        this.dropdownButton.classList.add('shade-dropdown__button--selected');
        this.dropdownButton.style.setProperty("--shade-color", shadeOption.getAttribute('data-shade-color'));
        this.dropdownButton.style.setProperty("--shade-text-color", shadeOption.getAttribute('data-shade-text-color'));
        this.dropdownButtonText.innerHTML = `<span>Second Shade</span> Selected: <em>${shadeOption.getAttribute('data-shade-title')}</em>`;

        if (shadeOption.id === 'shade-perfect-match') {
          this.dropdownButton.classList.add('shade-dropdown__button--perfect-match');
        }

        if (this.QuizUpsellItems) {
          this.QuizUpsellItems.setAttribute('data-second-shade', shadeOption.value);
        }
      } else {
        this.classList.add('shade-dropdown--error');
      }
    }

    toggle() {
      let isClosed = this.dropdown?.getAttribute('aria-hidden') === 'true' ? true : false;

      if (isClosed) {
        this.open();
      } else {
        this.close();
      }
    }

    open() {
      this.dropdownButton?.setAttribute('aria-expanded', true);
      this.dropdown?.setAttribute('aria-hidden', false);
    }

    close() {
      this.dropdownButton?.setAttribute('aria-expanded', false);
      this.dropdown?.setAttribute('aria-hidden', true);
    }

    selectShadeError() {
      this.classList.add('shade-dropdown--error');
      this.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
    }
  }

  customElements.define('shade-dropdown', ShadeDropdown);
}